import { useState } from "react";
import { Card } from "../Card";
import styled from "styled-components";
import { Button } from "../Button";
import { startBatchSigningProcess } from "../../../../api/api";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { CloseDocumentButton } from "../../../../theme/Theme.Button";
import BudgetPreview from "./BudgetPreview";
import { H4Heading } from "../../../../components/text/Headings";
import Alert from "../../../../components/Alert";
import { displayBudgetText } from "../displayBudgetText";
import DocumentDialog from "./DocumentDialog";

const BudgetSingle = ({ budget, user }) => {
	const navigate = useNavigate();
	const queryClient = useQueryClient();

	const [showDialog, setShowDialog] = useState(false);
	const [error, setError] = useState(null);

	const startSigningProcess = async (flowId) => {
		const payload = {
			budgetFlowIds: [flowId],
			signer: {
				email: user.user.contactDetails.mail,
				name: user.user.id,
			},
		};

		if (!payload.signer.email) {
			setError("Mangler e-postadresse for å kunne signere budsjettene.");
			setTimeout(() => {
				setError(null);
			}, 10000);
			return null;
		}

		try {
			const { id } = await startBatchSigningProcess(payload);
			return id;
		} catch {
			setError("Noe gikk galt.");
			setTimeout(() => {
				setError(null);
			}, 10000);
			return null;
		}
	};

	const mutation = useMutation(startSigningProcess, {
		onSuccess: () => {
			queryClient.invalidateQueries(["pending-batch-signings"]);
			queryClient.invalidateQueries(["pending-budgets"]);
		},
	});

	const handleSubmit = async (flowId) => {
		const signingFlowId = await mutation.mutateAsync(flowId);
		if (signingFlowId) {
			navigate(`/tasks/signing-batch/${signingFlowId}`);
		}
	};

	const title = displayBudgetText({
		...budget?.data?.budgetData,
		signingType: budget.data?.signingType,
	});

	return (
		<div>
			{error && (
				<FlexRow>
					<AlertWrapper>
						<Alert type="warning">{error}</Alert>
					</AlertWrapper>
				</FlexRow>
			)}

			<H4Heading>{"Start signering"}</H4Heading>
			<Card
				key={budget.flowId}
				title={title}
				action={
					<ButtonsContainer>
						<Button type={"outline"} onClick={() => setShowDialog(true)}>
							Forhåndsvis
						</Button>
						<Button
							type={"solid"}
							onClick={() => handleSubmit(budget.flowId)}
							disabled={mutation.isLoading}
						>
							Signer
						</Button>
					</ButtonsContainer>
				}
			></Card>
			<DocumentDialog
				open={showDialog}
				onOpenChange={setShowDialog}
				width="fit-content"
			>
				<CloseDocumentButton onClick={() => setShowDialog(false)} />
				<BudgetPreview
					flowId={budget.flowId}
					attachmentKey={budget.data.budgetData.document.attachmentId}
					mimeType={budget.data.budgetData.document.mimetype}
					title={title}
				/>
			</DocumentDialog>
		</div>
	);
};

export default BudgetSingle;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
`;

const AlertWrapper = styled.div`
  margin-bottom: 10px;
  width: 450px;
`;
